/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { JSX } from "react"

export const FullscreenSpinner = (): JSX.Element => (
    <div className="flex justify-center items-center h-screen w-screen">
        <div className="spinner-border text-legacy-primary" role="status" />
    </div>
)

/**
 * Loader for the content page (e.g. right to the side menu)
 * */
export const ContentSpinner = (): JSX.Element => (
    <div className="flex justify-center items-center w-full h-full" style={{ minHeight: "300px" }}>
        <div className="spinner-border text-legacy-primary" role="status" />
    </div>
)
